// import React  from 'react'


export default class VExportPaymentBaseTotalItem
{
	constructor(item) 
	{
		if(item!==undefined)
		{
			this.initialize(item);
		}
	}

	async initialize(item)
	{
		this.ExportPaymentId = item.exportPaymentId; 
        this.ExportId = item.exportId; 
        this.PaymentMethodName = item.paymentMethodName; 
        this.CurrencyCode = item.currencyCode; 
        this.CurrencySymbol = item.currencySymbol; 
        this.PaymentCount = item.paymentCount; 
        this.FeeBase = item.feeBase; 
        this.FeeAdjustment = item.feeAdjustment; 
        this.Fee = item.fee; 
        this.Reimbursement = item.reimbursement; 
        this.Misc = item.misc; 
        this.Travel = item.travel; 
        this.Gaming = item.gaming; 
        this.Expense = item.expense; 
        this.Vat = item.vat; 

	}

	static NameOfTheIdField(){return "ExportPaymentId";}
	static nameOfTheItemDetailList() {return "Export";}

	static MoneyFields= [
		"FeeBase",
		"FeeAdjustment",
		"Fee",
		"Reimbursement",
		"Misc",
		"Travel",
		"Gaming",
		"Expense",
		"Vat",
	];


	static Currency() {return "CurrencyCode"};

	static MoneyFieldsSecondary= [];

	static CurrencySecondary(){return ""};

	static DateFields=[	];
	

	static BoolFields= [];
	

	static FieldsToShowInListTable=[
		{tabName:"Info", tabLabel:"Info", icon:"fa-solid fa-info" , data:[
			{name:"OfficeName", label:"Office",className:"text-left"},
		]},	
	];


	//Meaning of data field: 
	//   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field 
	//   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function 
	//			and the field shows the result of this function
	//   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
	static FieldsToShowInDataTable()
	{ 
		return [
			// {label: "ExportPaymentId", orderById: "", data:"ExportPaymentId",  minWidth:50},
			{label: "Export Id", orderById: "", data:"ExportId", minWidth:50, className:"text-left"},
			{label: "Payment Method", orderById: "", data:"PaymentMethodName", minWidth:50, className:"text-left"},
			{label: "Currency", orderById: "", data:"CurrencyCode", minWidth:50, className:"text-left"},
			{label: "# Payment", orderById: "", data:"PaymentCount", minWidth:50, className:"text-left"},
			{label: "Fee Base", orderById: "", data:"FeeBase", minWidth:50, className:"text-right"},
			{label: "Fee Adjustment", orderById: "", data:"FeeAdjustment", minWidth:50, className:"text-right"},
			{label: "Fee", orderById: "", data:"Fee", minWidth:50, className:"text-right"},
			{label: "Reimbursement", orderById: "", data:"Reimbursement", minWidth:50, className:"text-right"},
			{label: "Misc", orderById: "", data:"Misc", minWidth:50, className:"text-right"},
			{label: "Travel", orderById: "", data:"Travel", minWidth:50, className:"text-right"},
			{label: "Gaming", orderById: "", data:"Gaming", minWidth:50, className:"text-right"},
			{label: "Expense", orderById: "", data:"Expense", minWidth:50, className:"text-right"},
			{label: "Vat", orderById: "", data:"Vat", minWidth:50},
		];
	}
	


}
 